import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchTextStyle({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="m9.195 7 4.087 11H12.08l-.013-.038-1.188-3.296H6.411L5.211 18H4l.03-.078L8.094 7h1.1zm7.868 2.826c1.811 0 2.937 1.014 2.937 2.646v5.4h-1.054v-1.345C18.46 17.416 17.435 18 16.33 18c-1.574 0-2.631-.943-2.631-2.346 0-1.376 1.007-2.2 2.837-2.323l2.364-.147v-.622c0-1.091-.695-1.743-1.86-1.743-1.096 0-1.82.532-1.99 1.461l-.008.047H13.98l.005-.062c.119-1.482 1.327-2.439 3.079-2.439zM18.9 14.08l-2.237.153c-1.193.081-1.85.586-1.85 1.422 0 .81.707 1.376 1.719 1.376 1.328 0 2.368-.944 2.368-2.149v-.802zM8.645 8.44l-1.884 5.222h3.768L8.645 8.439z"/>
        </svg>
    );
}

export default IconSearchTextStyle;
